import { MODEL_SECTION_TO_CLASS_NAME } from 'models/constants/class-name-to-section'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'

function getClassNameFromSectionModelUtil (section) {
  return (
    MODEL_SECTION_TO_CLASS_NAME[section] || CATEGORY_MODEL_CLASS_NAME
  )
}

export {
  getClassNameFromSectionModelUtil
}
